import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IQrBatchItem, IQRCodeBatchItem } from '../../qr-products.interface';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BehaviorSubject, Subscription } from 'rxjs';
import { QrProductsService } from '../../qr-products.service';
import { UtilitiesService } from '@services/utilities.service';

@Component({
  selector: 'app-modal-confirm-download',
  templateUrl: './modal-confirm-download.component.html',
  styleUrls: ['./modal-confirm-download.component.scss'],
})
export class ModalConfirmDownloadComponent implements OnInit, OnDestroy {
  @Input() selectedBatch: BehaviorSubject<IQrBatchItem | null>;

  @ViewChild('modalConfirmDownload') confirmDialog: ModalComponent;
  modalConfig: ModalConfig = {
    modalTitle: 'Unduh Batch QR',
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Unduh',
    onDismiss: () => this.dismissConfirmDialog(),
  };

  @ViewChild('modalResponseDownload') responseDialog: ModalComponent;
  modalConfigResponse: ModalConfig = {
    dismissButtonLabel: 'Oke',
    hideCloseButton: () => true,
    disableDismissButton: () => this.loadingFetchQR.value,
  };

  loadingFetchQR = new BehaviorSubject(false);

  private unsubscribe: Subscription[] = [];

  constructor(private qrProductService: QrProductsService, private utilitiesService: UtilitiesService) {}

  ngOnInit() {}

  openConfirmDialog() {
    return this.confirmDialog.open();
  }

  dismissConfirmDialog() {
    this.loadingFetchQR.next(true);
    this.confirmDialog.close().then(() => this.fetchQRBatchData());

    // open response dialog and reload page on close
    this.responseDialog.open().then(() => location.reload());
    return true;
  }

  fetchQRBatchData() {
    const { id, batch_name } = this.selectedBatch.value as IQrBatchItem;
    const _fileName = batch_name.replace(' ', '_');

    const _fetchQRSubs = this.qrProductService.downloadQRBatch(id).subscribe((resp) => {
      if (!resp) {
        return;
      }

      if (resp && !resp.success) {
        return setTimeout(() => this.responseDialog.close(), 250);
      }

      const { data } = resp;
      this.utilitiesService.downloadFile<IQRCodeBatchItem>(data, _fileName, ['brand_id', 'brand_name', 'qr_code_r1', 'qr_code_r2']);
      this.loadingFetchQR.next(false);
    });

    this.unsubscribe.push(_fetchQRSubs);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
